// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'uw-delete-entity-dialog',
    templateUrl: './delete-entity-dialog.component.html',
    imports: [MatProgressBar, MatButton, TranslateModule]
})
export class DeleteEntityDialogComponent implements OnInit {
  // Public properties
  viewLoading = false;

  constructor(
    public dialogRef: MatDialogRef<DeleteEntityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close(true); // Keep only this row
  }
}
